import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { discountDefSchema } from './entities';

export const types = {
  CREATE_DISCOUNT_ERROR: 'discounts/listPage/CREATE_DISCOUNT_ERROR',
  CREATE_DISCOUNT_REQUEST: 'discounts/listPage/CREATE_DISCOUNT_REQUEST',
  CREATE_DISCOUNT_SUCCESS: 'discounts/listPage/CREATE_DISCOUNT_SUCCESS',
  NEW_DISCOUNT_MODAL_CLOSE: 'discounts/listPage/NEW_DISCOUNT_MODAL_CLOSE',
  NEW_DISCOUNT_MODAL_OPEN: 'discounts/listPage/NEW_DISCOUNT_MODAL_OPEN',
  RECEIVE_DISCOUNT_DEFINITIONS:
    'discounts/listPage/RECEIVE_DISCOUNT_DEFINITIONS',
};

export const createDiscount = {
  error: notify(
    (error) => ({
      type: types.CREATE_DISCOUNT_ERROR,
      payload: error,
    }),
    'Failed to create Discount',
  ),
  request: (payload) => ({
    type: types.CREATE_DISCOUNT_REQUEST,
    payload,
  }),
  success: ({ discount }) => ({
    type: types.CREATE_DISCOUNT_SUCCESS,
    payload: normalize(discount, discountDefSchema),
  }),
};

export const newDiscountModal = {
  close: () => ({
    type: types.NEW_DISCOUNT_MODAL_CLOSE,
  }),
  open: () => ({
    type: types.NEW_DISCOUNT_MODAL_OPEN,
  }),
};

export const entities = {
  recieveDiscountDefs: ({ discountDefs }) => ({
    type: types.RECEIVE_DISCOUNT_DEFINITIONS,
    payload: normalize(discountDefs, [discountDefSchema]),
  }),
};
